import { ToastContext } from '@/context/toast/index'
import api from '@/services/api/eclips.js'
import packageAPI from '@/services/api/packages.js'
import { useContext, useState, useRef } from 'react'
import KeyHelper from '@/utils/key-helper'

const useEclips = () => {

	const { addToastMessage } = useContext(ToastContext)


	const [items, setItems] = useState([])
	const [meta, setMeta] = useState(null)
	const [currentItem, setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(true)
	const [error, setErrorMsg] = useState()
	const [folders, setFolders] = useState();
	const [eclips, setEclips] = useState();
	const [eclipsMeta, setEclipsMeta] = useState();
	const [activity, setActivity] = useState();
	const [currentDataElement, setCurrentDataElement] = useState();
	const [dataElements, setDataElements] = useState();
	const [receivedEclips, setReceivedEclips] = useState();
	const [receivedMessages, setReceivedMessages] = useState();

	const [receivedEclipsMeta, setReceivedEclipsMeta] = useState();
	const [receivedMessagesMeta, setReceivedMessagesMeta] = useState();

	const lastRequestPayloadKeyRef = useRef(null)

	async function fetch(type, option) {
		const currentPayloadKey = KeyHelper.createKeyOfObject({ type, option })

		if(KeyHelper.isSameKey(lastRequestPayloadKeyRef.current, currentPayloadKey)) return;

		lastRequestPayloadKeyRef.current = currentPayloadKey

		setLoading(true)
		const [error, response] = await api.findAll(type, option)
		setLoading(false)
		if (error) {
			return setErrorMsg(error)
		}
		const { items, meta } = response
		if (!Array.isArray(items)) {
			return setErrorMsg('Eclips is not an array')
		}
		setMeta(meta)
		setItems(items)
	}

	async function get(id) {
		setLoading(true)
		const [error, response] = await api.get(id)
		setLoading(false)
		if (error) {
			return setErrorMsg(error)
		}
		setCurrentItem(response)
	}

	async function update(id, payload, fetchId) {

		setLoading(true)
		const [error, response] = await api.update(id, payload)

		if(fetchId){
			await get(id)
		}

		setLoading(false)
		if (error) {
		    setErrorMsg(error)
			return error
		}
	}

	async function importMessageData(eclipId, messageStoreId) {
		setLoading(true)
		const [error, response] = await api.importMessageData(eclipId, messageStoreId)
		setLoading(false)
		if (error) {
			return setErrorMsg(error);
		}
	}

	async function addRemoveDataElements(eclipId, type, dataElements) {
		setLoading(true)
		const [error, response] = await api.addRemoveDataElements(eclipId, {
			type,
			dataElements
		})
		setLoading(false)
		if (error) {
			return setErrorMsg(error);
		}
	}

	async function send(id, payload) {

		setLoading(true)

		const [error, response] = await api.send(id, payload)

		setLoading(false)

		if (error) {
			return setErrorMsg(error);
		}
		return response;
	}


	async function requestMoreInfo(id, payload) {

		setLoading(true)

		const [error, response] = await api.requestMoreInfo(id, payload)

		setLoading(false)

		if (error) {
			return setErrorMsg(error);
		}
		return [error, response];
	}


	async function setRefNumber(id, payload) {

		setLoading(true)

		const [error, response] = await api.setRefNumber(id, payload)

		setLoading(false)

		if (error) {
			return setErrorMsg(error);
		}
		return [error, response];
	}

	async function create(payload) {
		return new Promise(async (resolve, reject) => {
			setLoading(true)
			const [error, response] = await api.create(payload)
			setLoading(false)
			if (error) {
				return reject(error)
			}

			return resolve(response)
		})
	}

	async function getDataElements(payload) {

		const params = payload || {};

		const [error, response] = await api.getDataElements({ params });


		if (error) {
			setDataElements([])
			return setErrorMsg(error);
		}

		setDataElements(response);
	}

	async function getReceivedEclips(dataElementId, payload) {

		setLoading(true)
		const params = payload || {};

		const [error, response] = await api.getReceivedEclips(dataElementId, { params });

		setLoading(false)

		if (error) {
			return setErrorMsg(error);
		}

		setReceivedEclips(response.items);
		setReceivedEclipsMeta(response.meta);
	}

	async function clearImportData(eclipId, dataElementId) {

		setLoading(true)
		const [error, response] = await api.clearImportData(eclipId, dataElementId);
		setLoading(false)

		if (error) {
			addToastMessage('Clear Import Data API has error', 'error')
			return setErrorMsg(error);
		}
	}

	async function packageOwnerUpdate(eclipId, ownerEmail) {

		setLoading(true)
		const [error, response] = await api.packageOwnerUpdate(eclipId, {
			ownerEmail
		});
		setLoading(false)

		if (error) {
			addToastMessage('Package owner updated failed', "error")
			return setErrorMsg(error);
		}
	}

	async function getReceivedMessages(dataElementId, payload) {

		setLoading(true)
		const params = payload || {};

		const [error, response] = await api.getReceivedMessages(dataElementId, { params });

		setLoading(false)

		if (error) {
			return setErrorMsg(error);
		}

		setReceivedMessages(response.items);
		setReceivedMessagesMeta(response.meta);
	}

	async function getFolders(payload) {

		setLoading(true)
		const params = payload || {};

		const [error, response] = await api.index(params);

		setLoading(false)

		if (error) {
			return setErrorMsg(error);
		}


		const { items, meta } = response;

		setFolders(items);
	}

	async function getAll(params = {}) {
		setLoading(true);

		const [error, response] = await api.findAll(params);
		setLoading(false);
		if (error) {
			return setErrorMsg(error);
		}
		const { items, meta } = response;
		setEclips(items)
		setEclipsMeta(meta)
	}

	async function getActivityLog(id) {
		const [error, response] = await api.activityLog(id);
		setActivity(response)
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	async function respondRequest(eclipId, action, payload) {

		setLoading(true)

		const [error, response] = await api.respondRequest(eclipId, action, payload)

		setLoading(false)

		if (error) {
			return setErrorMsg(error);
		}
	}

	return {
		packageOwnerUpdate,
		create,
		respondRequest,
		currentItem,
		error,
		fetch,
		items,
		loading,
		meta,
		update,
		setLoading,
		setCurrentItem,
		setItems,
		view,
		send,
		get,
		getFolders,
		folders,
		eclips,
		eclipsMeta,
		getAll,
		requestMoreInfo,
		setRefNumber,
		getActivityLog,
		activity,
		dataElements,
		setDataElements,
		getDataElements,
		receivedEclips,
		setReceivedEclips,
		receivedEclipsMeta,
		receivedMessagesMeta,
		getReceivedEclips,
		receivedMessages,
		setReceivedMessages,
		getReceivedMessages,
		setCurrentDataElement,
		currentDataElement,
		importMessageData,
		addRemoveDataElements,
		clearImportData
	}

}

export default useEclips;
